const locale = {
	OVERVIEW: "Übersicht",
	BUSINESSSUITESETTINGS: "Business Suite Einstellungen",
	USERMANAGEMENT: "Benutzerverwaltung",
	COMPANYSETTINGS: "Firmeneinstellungen",
	FILESIZETOOBIG: "Diese Datei ist zu groß!",
	COMPANYLOGO: "Firmenlogo",
	COMPANYNAME: "Firmenbezeichnung",
	COMPANYSHORTNAME: "Firmenkürzel",
	SAVE: "Speichern",
	YES: "Ja",
	NO: "Nein",
	CANCEL: "Abbrechen",
	CLOSE: "Schließen",
	SUCCESS: "Erfolgreich",
	QUITWITHOUTSAVING: "Möchten Sie wirklich ohne zu speichern fortfahren?",
	ATTENTION: "Achtung",
	COMPANYWIDESETTINGS: "Unternehmensweite Einstellungen",
	YOUDONTHAVEADMINRIGHTS: "Sie haben aktuell keine Administratorenrechte",
	USERSETTINGS: "Benutzereinstellungen",
	DEFAULTUSERSETTINGS: "Standard Benutzereinstellungen",
	TLSETTINGS: "TimeLite Einstellungen",
	USEREMAIL: "E-Mail",
	USERPHONE: "Telefonnummer",
	USERPASSWORD: "Passwort",
	CHANGEPASSWORD: "Passwort ändern",
	SECURITY: "Sicherheit",
	CONTACTINFORMATION: "Kontaktinformationen",
	APPEARANCE: "Erscheinungsbild",
	CHANGECOLOR: "Profilfarbe ändern",
	SELECTCOLOR: "Profilfarbe auswählen",
	ALL: "Alle",
	ROWSPERPAGE: "Zeilen per Seite",
	OF: "von",
	QUICKSEARCH: "Schnellsuche",
	NOUSERSFOUND: "Es konnten keine passenden Benutzer gefunden werden",
	FIRSTNAME: "Vorname",
	LASTNAME: "Nachname",
	USERNAME: "Benutzername",
	EMAIL: "E-Mail",
	PHONE: "Telefon",
	STATUS: "Status",
	LASTONLINE: "Zuletzt online",
	DEACTIVE: "Deaktiviert",
	ACTIVE: "Normal",
	DELETED: "Gelöscht",
	LOCKEDOUT: "Gesperrt",
	NEVER: "Nie",
	UNLOCK: "Entsperren",
	DISABLE: "Deaktivieren",
	ENABLE: "Aktivieren",
	DELETE: "Löschen",
	RESETPASSWORD: "Passwort zurücksetzen",
	IMPERSONATE_USER: "Benutzer imitieren",
	CREATEUSER: "Benutzer erstellen",
	EDITUSER: "Benutzer bearbeiten",
	BASEINFOS: "Basisinfos",
	LICENCES: "Lizenzen",
	ADMINROLES: "Adminrollen",
	METADATA: "Metadaten",
	FIRSTNAME: "Vorname",
	FIRSTNAME2: "2. Vorname",
	LASTNAME: "Nachname",
	PRETITLE: "Titel vorgestellt",
	POSTTITLE: "Titel nachgestellt",
	BIRTHDATE: "Geburtsdatum",
	CANCHANGEPASSWORD: "Kann Passwort ändern",
	COMMENT: "Kommentar",
	COUNTRY: "Land",
	PROVINCE: "Bundesland/Region",
	POSTALCODE: "Postleitzahl",
	CITY: "Stadt",
	STREET: "Straße",
	ADDRESSADDITION: "Adresszusatz",
	NEWPASSWORD: "Neues Passwort",
	NEWPASSWORDCONFIRM: "Neues Passwort wiederholen",
	FIELDREQUIRED: "Dieses Feld muss ausgefüllt werden",
	INVALIDINPUT: "Ihre Eingabe enthält ungültige Zeichen",
	PASSWORDSMUSTMATCH: "Passwörter stimmen nicht überein",
	IVALIDEMAILFORMAT: "Falsches E-Mail Format",
	IVALIDEPHONEFORMAT: "Falsches Telefonnummer Format",
	USERCREATEDAT: "Benutzer wurde erstellt am",
	CREATEDOF: "von",
	UNKNOWN: "Unbekannt",
	ROLENAME: "Rollenname",
	ROLEWEIGHT: "Gewichtung",
	ROLEDESCRIPTION: "Beschreibung",
	ASSIGNEDUSERS: "Zugewiesen",
	ADDTHISUSER: "Hinzufügen",
	REMOVETHISUSER: "Entfernen",
	DEFAULT: "Standardmäßig",
	ALLASSIGNED: "Alle vergeben",
	DELETEQUESTION: "Möchten Sie wirklich mit dem Löschen fortfahren?",
	PASSWORDRESETQUESTION: "Wenn Sie fortfahren, dann bekommen die ausgewählten Benutzer eine Mail mit den weiteren Anweisungen zum Zuürcksetzen des Passwortes. Fortfahren?",
	PASSWORTREQUESTDONE: "Passwort Rücksetzungsmails wurden versendet.",
	ADMINISTRATION: "Administration",
	MANAGEWORKMODES: "Arbeitsmodi",
	WORKMODEHASASSIGNMENTS: "Berechnungsrelevante Einstellungen können nur geändert werden, wenn dieser Arbeitsmodus keine Zuweisungen hat.",
	WORKMODEHASASSIGNMENTSCANNOTDELETE: "Dieser Arbeitsmodus hat Zuweisungen und kann nicht gelöscht werden.",
	WORKMODE: "Arbeitsmodus",
	ALLUSERS: "Alle Benutzer",
	NOENDDATE: "Kein Enddatum",
	CREATEWORKMODE: "Arbeitsmodus erstellen",
	EDITWORKMODE: "Arbeitsmodus bearbeiten",
	COPYWORKMODE: "Arbeitsmodus kopieren",
	DELETEWORKMODE: "Arbeitsmodus löschen",
	WORKMODEDELETEQUESTION: "Arbeitsmodus {{status}} löschen?",
	DELETEASSIGNMENT: "Zuweisung löschen",
	COPYASSIGNMENT: "Zuweisung kopieren",
	ASSIGNMENTDELETEQUESTION: "Diese Zuweisung löschen?",
	NOMATCHINGENTRIES: "Keine passenden Einträge.",
	RELOAD: "Neu laden",
	LOADINGWORKMODES: "Arbeitsmodi werden geladen",
	WORKMODESLOADFAILED: "Die Arbeitsmodi konnten nicht geladen werden. Bitte erneut laden.",
	USEWORKMODEDEFAULT: "Standard des Arbeitsmodus verwenden",
	WORKMODEINHERITHELP: "Geerbte Werte stammen aus der Arbeitsmodusdefinition. Null als Zahlenwert ist eine ausdrückliche Überschreibung.",
	SECONDS: "Sekunden",
	IDENTITYANDDISPLAY: "Identität und Darstellung",
	ACTIVITYBEHAVIOR: "Aktivitätsverhalten",
	REQUESTDEFAULTS: "Antragsvorgaben",
	DURATIONLEADANDFOLLOWUPLIMITS: "Dauer-, Vorlauf- und Nachlaufgrenzen",
	ROUNDING: "Rundung",
	ACTIVITYDESCRIPTIONS: "Aktivitätsbeschreibungen",
	STATUSID: "Arbeitsmodus-ID",
	STATUSBEZEICHNUNG: "Bezeichnung",
	STATUSGROUP: "Gruppe",
	ACTIVEPRESENCE: "Aktive Anwesenheit",
	INACTIVEPRESENCE: "Inaktive Anwesenheit",
	PASSIVEPRESENCE: "Passive Anwesenheit",
	ABSENCE: "Abwesenheit",
	VACATION: "Urlaub",
	EXEMPTION: "Freistellung",
	SORTINGNUMBER: "Sortierreihenfolge",
	LIVESTART: "Live einstempeln",
	LIVEEND: "Live ausstempeln",
	MUSTBEINSIDE: "Erforderliches Zeitfenster",
	PAID: "Bezahlt",
	REPORTPOINTOUT: "In Berichten hervorheben",
	OFFSETTINGMETHOD: "Verrechnungsmethode",
	UNIT: "Einheit",
	ADVISEDUNIT: "Vorgeschlagene Einheit",
	MINIMALVALID: "Mindestdauer",
	MOREDAYSALLOW: "Mehrere Tage erlauben",
	MOREDAYSFILL: "Mehrere Tage füllen mit",
	AUTOENDONLIVE: "Live-Aktivität automatisch beenden nach",
	MAXPLAINCOUNTINGDURATIONSINGLE: "Maximal zulässige Dauer pro Aktivität",
	MAXPLAINCOUNTINGDURATIONDAY: "Maximal zulässige Dauer pro Tag",
	MAXDURATIONOPEN: "Maximale offene Dauer",
	LEADTIME: "Maximaler Vorlauf",
	LEADTIMENEG: "Maximaler negativer Vorlauf",
	LEADTIMEMAN: "Manuellen Vorlauf erlauben",
	FOLLOWUPTIME: "Maximaler Nachlauf",
	FOLLOWUPTIMENEG: "Maximaler negativer Nachlauf",
	FOLLOWUPTIMEMAN: "Manuellen Nachlauf erlauben",
	ROUNDEDTIMEBEGINMODE: "Aktivitätsbeginn runden",
	ROUNDEDTIMEENDMODE: "Aktivitätsende runden",
	ACTIVITYDESCRIPTIONWITHOUT: "Beschreibung ohne Projekt",
	ACTIVITYDESCRIPTIONWITHPROJECT: "Beschreibung mit Projekt",
	REQUESTONLIVESTART: "Antrag beim Einstempeln erforderlich",
	REQUESTONLIVEEND: "Antrag beim Ausstempeln erforderlich",
	REQUESTONLIVEOFFLINE: "Antrag bei Offline-Stempelung erforderlich",
	REQUESTONCREATE: "Antrag beim Erstellen erforderlich",
	REQUESTONEDIT: "Antrag beim Bearbeiten erforderlich",
	REQUESTONDELETE: "Antrag beim Löschen erforderlich",
	REQUESTONOUTSIDEFLEX: "Antrag außerhalb der Gleitzeit erforderlich",
	ROUNDINGINTERVAL: "Intervall in Minuten",
	DURATIONAMOUNT: "Anzahl",
	DURATIONUNIT: "Einheit",
	DAYOFFSET: "Tage nach Aktivitätsbeginn",
	TIMEOFDAY: "Uhrzeit",
	FLEXTIME: "Gleitzeit",
	NORMALWORKINGTIME: "Normalarbeitszeit",
	CORETIME: "Kernzeit",
	TIME: "Zeit",
	MONEY: "Geld",
	HOURS: "Stunden",
	HALFDAYS: "Halbe Tage",
	DAYS: "Tage",
	ALLDAYS: "Alle Tage",
	NOTALLOWED: "Nicht erlaubt",
	OPTIONAL: "Optional",
	REQUIRED: "Erforderlich",
	MANAGEOBJECTS: "Objekte",
	TIMELITE: "TimeLite",
	GENERAL: "Allgemein",
	SYSTEMSETTINGS: "System Einstellungen",
	REPORTSLOGO: "Reporte Logo",
	EDITLOGO: "Logo ändern",
	REMOVELOGO: "Logo entfernen",
	DEFAULTSYSTEMLANGUAGE: "Standard Systemsprache",
	MANAGEANNUALPERIODS: "Zeiterfassungsperioden",
	MANAGEHIERARCHY: "Organigramm",
	LIVECLOCKINTYPE: "Echtzeit Einstempelart",
	DIALOG: "Dialog",
	INSTANT: "Sofort",
	QUICK: "Schnell",
	NEWACTIVITYDEFAULTS: "Neue Aktivität Standardauswahl",
	NOTSET: "Nicht gesetzt",
	LIKELASTACTIVITY: "Wie letzte Aktivität",
	FIXEDSET: "Fix definiert",
	DEFAULTSTATUS: "Standard Arbeitsmodus",
	DEFAULTOBJECTS: "Zuordnung an {{objects}}",
	PREFERREDSUPERVISOR: "Bevorzugter Vorgesetzter",
	AUTOANNUALPERIODBEFOREEND: "Zeiterfassungsperiode automatisch erneuern",
	DAYSBEFOREEND: "Tage vor Ablauf",
	ANNUALPERIODS: "Zeiterfassungsperioden",
	SUPERVISORCHECKMETHOD: "Vorgesetztenermittlungsmethode",
	LIVEDATE: "Livedatum",
	ONDATE: "Am ausgewählten Tag",
	FROM: "Von",
	TO: "Bis",
	DESCRIPTION: "Beschreibung",
	APERIODDELETEQUESTION: "Möchten Sie diese Zeiterfassungsperiode wirklich löschen?",
	NEWAPERIOD: "Neue Zeiterfassungsperiode",
	EDITAPERIOD: "Zeiterfassungsperiode bearbeiten",
	DELETEAPERIOD: "Zeiterfassungsperiode löschen",
	APERIODALREADYENDED: "Diese Periode ist bereits beendet und kann nicht bearbeitet werden",
	APERIODALREADYSTARTED: "Diese Periode hat bereits begonnen und kann nicht gelöscht werden",
	APERIODSERVERUNKNOWN: "Serverdatum ist unbekannt, Periode kann nicht erstellt werden",
	EMPLOYEDDATE: "Anstellungsdatum",
	INITIALEMPLOYEDDATE: "Erstanstellung",
	SEARCH: "Suchen",
	HIERARCHYLEFTHEADERTEXT: "Aktuelle Unternehmensstruktur",
	HIERARCHYRIGHTHEADERTEXT: "Verfügbare Benutzer / Gruppen",
	HIERARCHYFILLINGERROR: "Beim Laden der Struktur ist ein Fehler aufgetreten",
	HIERARCHYDRAGNOTVALID: "Diese Position ist nicht zulässig für diesen Benutzer",
	HIERARCHYROLESETTINGS: "Rolleneinstellungen",
	SUPERIORROLE: "Vorgesetztenrolle",
	UPWARDSINHERITANCE: "Zugriff auf Mitarbeiter für Vorgesetzte höherer Ebenen erlauben",
	DOWNWARDSINHERITANCE: "Zugriff für Vorgesetzte auf Mitarbeiter niedriegerer Ebenen erlauben",
	ROLEPASSDOWN: "Berechtigungen an Mitarbeiter niedrigerer Ebenen weitergeben",
	COMPANYSTRUCTURE: "Unternehmensstruktur",
	ASSIGNED: "Zugewiesen",
	HIERARCHYROLES: "Hierarchierollen",
	MANAGEHIERARCHYROLES: "Hierarchierollen verwalten",
	CREATEHIERARCHYROLE: "Hierarchierolle erstellen",
	EDITHIERARCHYROLE: "Hierarchierolle bearbeiten",
	DELETEHIERARCHYROLE: "Hierarchierolle löschen",
	NEWHIERARCHYROLE: "Neue Hierarchierolle",
	HIERARCHYROLEDELETEQUESTION: "Sind Sie sicher, dass Sie diese Hierarchierolle löschen möchten?",
	ROLENAME: "Rollenname",
	ROLEIDENTIFIER: "Rollenkennung",
	ROLENAME: "Rollenname",
	ROLEDESCRIPTION: "Rollenbeschreibung",
	PERMISSIONS: "Berechtigungen",
	CANVIEWSUBCALENDAR: "Kann Kalender von Untergeordneten ansehen",
	CANCREATESUBACTIVITIES: "Kann Aktivitäten für Untergeordnete erstellen",
	CANEDITSUBACTIVITIES: "Kann Aktivitäten von Untergeordneten bearbeiten",
	CANDELETESUBACTIVITIES: "Kann Aktivitäten von Untergeordneten löschen",
	CANMANAGESUBBALANCECOMP: "Kann Saldoausgleich von Untergeordneten verwalten",
	CANVIEWSUBREPORTS: "Kann Berichte von Untergeordneten ansehen",
	CANANSWERSUBREQUESTS: "Kann Anfragen von Untergeordneten beantworten",
	CANRECEIVESUBREQUESTS: "Kann Anfragen von Untergeordneten erhalten",
	CANSEALSUBDAYSORACTIVITIES: "Kann Tage oder Aktivitäten von Untergeordneten versiegeln",
	CANVIEWSUBTASKS: "Kann Aufgaben von Untergeordneten ansehen",
	CANCREATESUBTASKS: "Kann Aufgaben für Untergeordnete erstellen",
	CANEDITSUBTASKS: "Kann Aufgaben von Untergeordneten bearbeiten",
	CANDELETESUBTASKS: "Kann Aufgaben von Untergeordneten löschen",
	CANCLOSESUBTASKS: "Kann Aufgaben von Untergeordneten schließen oder wiedereröffnen",
	ROLEINUSE: "Diese Rolle ist derzeit Benutzern zugewiesen und kann nicht gelöscht werden",
	ROLEINUSEPERMISSIONSDISABLED: "Berechtigungen können nicht geändert werden, solange diese Rolle aktiv zugewiesen ist. Um die Berechtigungen zu ändern, entfernen Sie zuerst alle Benutzer aus dieser Rolle.",
	ROLEIDENTIFIEREXISTS: "Eine Rolle mit dieser Kennung existiert bereits",
	NONE: "Keine",
	COLOR: "Farbe",
	NOOBJECTASSIGNMENT: "Keine {{object}} Zuordnung",
	NOOBJECTSFOUND: "Keine {{objects}} gefunden",
	SELECTIONEXCEEDSMAX: "Auswahl übersteigt das Maximum",
	NAME: "Name",
	PLURALNAME: "Pluralname",
	MODE: "Modus",
	ICON: "Icon",
	MAXSELECT: "Max-Auswahl",
	SUBENABLED: "Unterobjekte",
	NEWOBJECT: "Neues Objekt",
	EDITOBJECT: "Objekt bearbeiten",
	DELETEOBJECT: "Objekt löschen",
	OBJECTHASITEMSCANNOTDELETE: "Dieses Objekt hat bestehende Einträge und kann nicht gelöscht werden",
	DOABLE: "Durchführbar",
	USABLE: "Benutzbar",
	SETTINGSFOR: "Einstellungen für",
	EXECUTEWEBCRON: "Webcron jetzt ausführen",
	WEBCRONRUNNING: "Webcron wird nun durchgeführt",
	EXKURSIO: "Exkursio",
	TASKSENABLED: "Aufgaben aktiviert",
	HOLIDAYMANAGEMENT: "Feiertagsverwaltung",
	MAINBUSINESSLOCATION: "Hauptstandort",
	QUICKINFOSRECALCAFTER: "Schnellinfos Neuberechnung Intervall",
	SECONDSAFTERRECALC: "Sekunden nach Neuberechnung",
	MINUTES: "Minuten",
	TEAMABSENCEVISIBLE: "Team-Abwesenheit sichtbare Status",
	PEOPLEVISIBILITY: "Personensichtbarkeit",
	PEOPLEVISIBILITY_PRIVATE: "Privat",
	PEOPLEVISIBILITY_INFOS: "Infos",
	PEOPLEVISIBILITY_LIVE: "Live",
	PEOPLEVISIBILITY_LIVEDETAIL: "Live Detail",
	PEOPLEVISIBILITY_FULLDAY: "Ganzer Tag",
	NORMTIME_SUBTRACT_TIMING: "Heutige Sollzeit Abzug",
	NORMTIME_SUBTRACT_STARTOFDAY: "Tagesbeginn",
	NORMTIME_SUBTRACT_REALTIME: "Echtzeit",
	NORMTIME_SUBTRACT_ENDOFDAY: "Tagesende",
	GENERAL: "Allgemein",
	REPORTSANDBRANDING: "Berichte & Branding",
	TIMETRACKINGSETTINGS: "Zeiterfassungseinstellungen",
	LOCATIONANDVISIBILITY: "Standort & Sichtbarkeit",
	LANGUAGE_DE: "Deutsch",
	LANGUAGE_EN: "Englisch",
	HOLIDAYTYPE: "Feiertagstyp",
	NEWHOLIDAY: "Neuer Feiertag",
	EDITHOLIDAY: "Feiertag bearbeiten",
	DELETEHOLIDAY: "Feiertag löschen",
	HOLIDAYDELETEQUESTION: "Möchten Sie diesen Feiertag wirklich löschen?",
	BUSINESSLOCATIONMANAGEMENT: "Standortverwaltung",
	RELIGIONMANAGEMENT: "Religionsverwaltung",
	NEWBUSINESSLOCATION: "Neuer Standort",
	EDITBUSINESSLOCATION: "Standort bearbeiten",
	DELETEBUSINESSLOCATION: "Standort löschen",
	BUSINESSLOCATIONINUSE: "Dieser Standort wird verwendet und kann nicht gelöscht werden",
	NEWRELIGION: "Neue Religion",
	EDITRELIGION: "Religion bearbeiten",
	DELETERELIGION: "Religion löschen",
	RELIGIONINUSE: "Diese Religion wird verwendet und kann nicht gelöscht werden",
	LOCATIONNAME: "Standortname",
	POSTALCODE: "Postleitzahl",
	CITY: "Stadt",
	CLEARALLCARRYOVERS: "Alle Jahresüberträge löschen",
	CLEARALLCARRYOVERSQUESTION: "Sind Sie sicher, dass Sie alle Jahresüberträge für alle Benutzer und alle Perioden löschen möchten?",
	CLEARALLCARRYOVERSINFO: "Alle Jahresüberträge (einschließlich Projektüberträge) wurden gelöscht.",
	RECALCALLANNUALPERIODS: "Alle Jahresperioden neu berechnen",
	RECALCALLANNUALPERIODSINFO: "Alle Salden für alle Benutzer werden neu berechnet, dies kann einige Minuten dauern.",
	ATTENTION: "Achtung",
	STREET: "Straße",
	ADDRESSADDITION: "Adresszusatz",
	RELIGIONNAME: "Religionsname",
	BUSINESSLOCATIONDELETEQUESTION: "Möchten Sie diesen Standort wirklich löschen?",
	RELIGIONDELETEQUESTION: "Möchten Sie diese Religion wirklich löschen?",
	PARTDAYTYPE: "Teiltagstyp",
	PARTDAY_FULL: "Ganztägig",
	PARTDAY_HALF_START: "Halbtag (Beginn)",
	PARTDAY_HALF_END: "Halbtag (Ende)",
	PARTDAY_HALF_UNTIL: "Halbtag bis",
	PARTDAY_HALF_FROM: "Halbtag ab",
	CUSTOMTIME: "Uhrzeit (HHMM)",
	CUSTOMTIMEHELPER: "Format: HHMM (z.B. 1200 für 12:00, 1330 für 13:30)",
	VALIDFROM: "Gültig von",
	VALIDUNTIL: "Gültig bis",
	DATETHISYEAR: "Datum Heuer",
	RELIGION: "Religion",
	SPECIALDATE: "Spezielles Datum",
	SPECIALNAME: "Spezialname",
	TOTALBALANCESHOWTYPE: "Arbeitskonto Anzeigetyp",
	CURRENTTOTALBALANCE: "Aktuelles Arbeitskonto",
	UNTILLASTMONTHTOTALBALANCE: "Arbeitskonto bis Ende letztes Monat",
	UNTILLASTWEEKTOTALBALANCE: "Arbeitskonto bis Ende letzter Woche",
	VACATIONBALANCEROUNDING: "Urlaubskonto Rundung",
	ROUNDUP: "Aufrunden",
	ROUNDDOWN: "Abrunden",
	ROUNDNEAREST: "Kaufmännisch runden",
	CANCREATEOBJECTITEMS: "Kann Objekteinträge erstellen",
	CANCREATETASKS: "Kann Aufgaben erstellen",
	CANMANAGEOWNBALANCECOMP: "Kann eigene Saldenausgleiche verwalten",
	SEALPOLICY: "Versiegelungsrichtlinie",
	UNSEALPOLICY: "Entsiegelungsrichtlinie",
	POLICY_FORBIDDEN: "Verboten",
	POLICY_ALLOW: "Erlauben",
	POLICY_REQUEST: "Genehmigung anfordern",
	LIVECLOCKINOROUT_TLAPP: "Echtzeit Ein-/Ausstempeln TLApp",
	LIVECLOCKINOROUT_ABSWEB: "Echtzeit Ein-/Ausstempeln ABSWeb",
	LIVECLOCKINOROUT_TLPANEL: "Echtzeit Ein-/Ausstempeln TLPanel",
	CANSEEOWNTOTALBALANCES: "Kann eigene Gesamtsalden sehen",
	ACTIVITYDESCRIPTION_SUGGESTIONS: "Tätigkeitsbeschreibung Vorschläge",
	ACTIVITYDESCRIPTION_SUGGESTIONS_HELP: "Anzahl der Vorschläge (0 = aus)",
	TRIPSUGGESTIONS_LIMIT: "Fahrtenvorschläge Limit",
	TRIPSUGGESTIONS_LIMIT_HELP: "Anzahl der Vorschläge für Fahrtenfelder (0 = aus)",
	INHERITEDFROMDEFAULT: "Von Standard geerbt",
	USEDEFAULT: "Standard verwenden",
	CLICKTOOVERRIDE: "Klicken um zu überschreiben",
	HARDWARE: "Hardware",
	NFCCHIPS: "NFC Chips",
	CHIPID: "Chip ID",
	CHIPNAME: "Chip Name",
	ENABLED: "Aktiviert",
	SCANCOUNT: "Scan Anzahl",
	LASTSEEN: "Zuletzt gesehen",
	LASTSEENCHIPTEXT: "Zuletzt gesehener Chip Text",
	CREATENEWNFCCHIP: "Neuen NFC Chip erstellen",
	EDITNFCCHIP: "NFC Chip bearbeiten",
	DELETENFCCHIP: "NFC Chip löschen",

	CHIPIDISREQUIRED: "Chip ID ist erforderlich",
	CHIPNAMEISREQUIRED: "Chip Name ist erforderlich",
	INVALIDCHIPIDFORMAT: "Ungültiges Chip ID Format",
	CONFIRMDELETECHIPMESSAGE: "Möchten Sie diesen Chip und alle seine Zuweisungen wirklich löschen?",
	CHIPHASSCANSCANNOTDELETE: "Dieser Chip hat bestehende Scandaten und kann nicht gelöscht werden",
	OK: "OK",
	ASSIGNMENTS: "Zuweisungen",
	USERASSIGNMENT: "Benutzerzuweisung",
	STARTDATE: "Startdatum",
	ENDDATE: "Enddatum",
	ASSIGNEDTO: "Zugewiesen an",
	NOASSIGNMENTS: "Keine Zuweisungen",
	NEWASSIGNMENT: "Neue Zuweisung",
	EDITASSIGNMENT: "Zuweisung bearbeiten",
	SELECTUSER: "Benutzer auswählen",
	UNASSIGNED: "Nicht zugewiesen",
	SPECIALEFFECTS: "Saisonale Effekte",
	SPECIALEFFECTS_DESCRIPTION: "Festliche Animationen während spezieller Jahreszeiten anzeigen (z.B. Weihnachten, Neujahr)",
	NOPERMISSION: "Sie haben keine Berechtigung, diese Einstellung zu ändern",
	ACTIVITY_TEMPLATES: "Aktivitätsvorlagen",
	ACTIVITY_TEMPLATES_COMPANY: "Firmenweite Aktivitätsvorlagen",
	ADD_TEMPLATE: "Vorlage hinzufügen",
	EDIT_TEMPLATE: "Vorlage bearbeiten",
	DELETE_TEMPLATE: "Vorlage löschen",
	DELETE_TEMPLATE_CONFIRM: "Möchten Sie diese Vorlage wirklich löschen?",
	TEMPLATE_NAME: "Vorlagenname",
	TEMPLATE_DESCRIPTION: "Beschreibungstext",
	ACTIVITYDESCRIPTION: "Tätigkeitsbeschreibung",
	TEMPLATE_STATUS: "Arbeitsmodus",
	TEMPLATE_OBJECTS: "Objekte",
	TEMPLATE_SAVED: "Vorlage gespeichert",
	TEMPLATE_DELETED: "Vorlage gelöscht",
	NO_TEMPLATES: "Noch keine Vorlagen",
	TEMPLATE_ITEMS_UNAVAILABLE: "Einige Elemente in dieser Vorlage sind nicht mehr zugewiesen oder zugänglich und werden ignoriert.",
	CONNECTED_ACCOUNTS: "Verknüpfte Konten",
	CONNECTED_ACCOUNTS_DESC: "Externe Konten, wie z.B. Microsoft 365, um Termine in TimeLite zu importieren.",
	NO_CONNECTED_ACCOUNTS: "Noch keine Konten verknüpft.",
	OAUTH_ADD_MICROSOFT: "Microsoft 365 Konto verknüpfen",
	OAUTH_ADD_GOOGLE: "Google Konto verknüpfen",
	OAUTH_DISCONNECT: "Verbindung trennen",
	OAUTH_DISCONNECT_CONFIRM: "Möchten Sie dieses Konto wirklich trennen? Alle gespeicherten Tokens werden gelöscht.",
	OAUTH_LINKED_SUCCESS: "Konto erfolgreich verknüpft.",
	OAUTH_ERROR_GENERIC: "Beim Verknüpfen des Kontos ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
	PROVIDER_MICROSOFT: "Microsoft 365",
	PROVIDER_GOOGLE: "Google",
	NOTIFICATION_DEFAULT_PREFERENCES: "Benachrichtigungen",
	NOTIFICATION_DEFAULT_PREFERENCES_TITLE: "Standard-Benachrichtigungseinstellungen",
	NOTIFICATION_DEFAULT_PREFERENCES_DESC: "Legen Sie systemweite Standardeinstellungen für die Zustellung jeder Benachrichtigungsart fest. Benutzer können diese in ihren persönlichen Einstellungen ändern.",
	NOTIF_CHANNEL_MAIL: "E-Mail",
	NOTIF_CHANNEL_PUSH: "Push (App)",
	NOTIF_MODE_INSTANT: "Sofort",
	NOTIF_MODE_DAILY: "Tägliche Zusammenfassung",
	NOTIF_MODE_OFF: "Aus",
	NOTIF_DAILY_SUMMARY_TIME: "Uhrzeit für tägliche Zusammenfassung",
	NOTIFTYPE_TASK_ASSIGNED: "Aufgabe zugewiesen",
	NOTIFTYPE_TASK_REASSIGNED: "Aufgabe neu zugewiesen",
	NOTIFTYPE_TASK_CLOSED: "Aufgabe abgeschlossen",
	NOTIFTYPE_TASK_REOPENED: "Aufgabe wieder geöffnet",
	NOTIFTYPE_TASK_OVERDUE: "Aufgabe überfällig",
	NOTIFTYPE_TASK_NOW_OPEN: "Aufgabe jetzt offen",
	NOTIFTYPE_REQUEST_RECEIVED: "Antrag eingegangen",
	NOTIFTYPE_REQUEST_FORWARDED: "Antrag weitergeleitet",
	NOTIFTYPE_REQUEST_ANSWERED: "Antrag beantwortet",
	NOTIFTYPE_ACTIVITY_ERROR: "Aktivitätsfehler",
	NOTIFTYPE_OBJECTITEM_ASSIGNED: "Objekt zugewiesen",
	NOTIFTYPE_OBJECTITEM_UNASSIGNED: "Objektzuweisung aufgehoben",
	NOTIFTYPE_REPORT_FINISHED: "Bericht erstellt",
	NOTIF_GROUP_TASKS: "Aufgaben",
	NOTIF_GROUP_REQUESTS: "Anträge",
	NOTIF_GROUP_OBJECTS: "Objekte",
	NOTIF_GROUP_ACTIVITIES: "Aktivitäten",
	NOTIF_GROUP_REPORTS: "Berichte",
	NOTIF_USER_SETTINGS: "Benachrichtigungen",
	NOTIF_PUSH_DEVICES: "Registrierte Push-Geräte",
	NOTIF_PUSH_DEVICES_EMPTY: "Keine Push-Geräte registriert.",
	NOTIF_PUSH_DEVICE_REMOVE: "Gerät entfernen",
	NOTIF_PUSH_DEVICE_REMOVE_CONFIRM: "Möchten Sie dieses Gerät wirklich entfernen?",
	NOTIF_PUSH_DEVICE_ENABLE: "Push-Benachrichtigungen für dieses Gerät aktivieren",
	NOTIF_PUSH_DEVICE_DISABLE: "Push-Benachrichtigungen für dieses Gerät deaktivieren",
	NOTIF_PUSH_DEVICE_SENDTEST: "Test-Push-Benachrichtigung senden",
	NOTIF_PUSH_DEVICE_TEST_SENT: "Test-Benachrichtigung gesendet.",
	PRODUCT: "Produkt",
	UNLIMITED: "Unbegrenzt",
	ASSIGNED: "Zugewiesen",
	OVER_THE_LIMIT: "Über dem Limit",
	AVAILABLE: "Verfügbar",
	LAST_WEBCRON_RUN: "Letzter Webcron",
	WEBCRON_INTERVAL: "Intervall",
	TOTAL_DB_SIZE: "Gesamte DB-Größe",
	WEBCRON_NEVER: "Nie",
	REQUEST_LICENCE_CHANGES: "Lizenzänderungen anfragen",
	LICENCE_CHANGE_REQUEST_MESSAGE: "Ich möchte Änderungen an den Produktlizenzen anfragen.",
};

export default locale;
